import { format } from 'date-fns';
import { Sampling } from 'src/shared/types/sampling';
import { Timeline } from 'src/shared/types/timeline';

type DeliveredDateResult = {
  date: string;
  is_expected: boolean;
};

const getDeliveredDate = (sampling: Sampling): DeliveredDateResult => {
  if (sampling.stage?.includes('rejected')) {
    return { date: 'Cancelled', is_expected: false };
  }

  const delivered = sampling?.timeline?.findLast(
    (value: Timeline) => value?.stage === 'delivered'
  );

  if (delivered?.finished_at) {
    return {
      date: format(delivered.finished_at, 'MMM dd, yyyy'),
      is_expected: false
    };
  }

  if (delivered?.estimated_finished_at) {
    return {
      date: format(delivered.estimated_finished_at, 'MMM dd, yyyy'),
      is_expected: true
    };
  }

  return {
    date: format(sampling.estimated_end_date, 'MMM dd, yyyy'),
    is_expected: true
  };
};

export default getDeliveredDate;
